import { useIntl } from "react-intl";

import FormSectionLabel from "pages/shipper/RequestFormV2/components/FormSectionLabel/FormSectionLabel";
import { useAttachments } from "@RequestFormV2/sections/Attachments/context/useAttachments";
import BucketAttachmentRow from "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection/BucketAttachmentRow";
import OtherFilesRow from "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection/OtherFilesRow";
import "@RequestFormV2/sections/Provider/components/UploadFreightDocumentsSection/UploadFreightDocumentsSection.scss";

export default function AttachmentsUploadSection() {
  const intl = useIntl();
  const { bucketAttachments, hasAttachmentBuckets, handleAddBucketFile, handleDeleteBucketFile } = useAttachments();

  const otherBucket = hasAttachmentBuckets ? bucketAttachments.find((b) => b.bucket_type === "other") : undefined;

  return (
    <div className="rfv2-form-section">
      <FormSectionLabel
        label={intl.formatMessage({
          id: "request-form.provider.uploadFreightDocuments.label",
          defaultMessage: "Upload freight documents",
        })}
      />

      <div className="rfv2-form-section__content">
        {hasAttachmentBuckets &&
          bucketAttachments
            .filter((b) => b.bucket_type !== "other")
            .map((bucket) => (
              <BucketAttachmentRow
                key={bucket.id}
                bucket={bucket}
                onAddFile={handleAddBucketFile}
                onDeleteFile={handleDeleteBucketFile}
              />
            ))}

        <OtherFilesRow otherBucket={otherBucket} />
      </div>
    </div>
  );
}
